import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito comprar productos caros para reemplazar los actuales?',
  a: 'No, muchas sustituciones son simples, con productos accesibles que encuentras fácilmente en cualquier supermercado.'
}, {
  q: '¿Cuánto tiempo al día toma seguir el plan?',
  a: 'Solo unos minutos para ajustar tu entorno y tu rutina, y notarás la diferencia sin interrumpir tu día. Aproximadamente 15-20 minutos diarios.'
}, {
  q: '¿Funciona si no vivo en EE.UU.?',
  a: 'Sí, aunque el enfoque es para mujeres latinas en EE.UU., los principios se aplican en cualquier lugar.'
}, {
  q: '¿Cuándo veré resultados?',
  a: 'Muchas mujeres notan cambios en los primeros 3 a 5 días, especialmente en la hinchazón y la energía. Resultados más profundos al completar los 7 días.'
}, {
  q: '¿El plan incluye recetas?',
  a: 'Incluye una matriz de sustitución alimentaria para ayudarte a elegir mejor, sin complicarte.'
}, {
  q: '¿Este detox es restrictivo como otros?',
  a: 'No, es un enfoque de eliminación de toxinas, no de restricción calórica.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-white" data-id="element-21">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-serif text-dark mb-6" data-id="element-24">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-25">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-sage-light rounded-2xl overflow-hidden bg-cream/50" data-id="element-26">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex justify-between items-center text-left focus:outline-none" data-id="element-27">
                <span className="font-medium text-dark text-lg pr-8" data-id="element-28">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-sage-dark shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-29" />
              </button>
              <AnimatePresence data-id="element-30">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-31">
                    <div className="px-6 pb-5 text-dark/70 leading-relaxed" data-id="element-32">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}